import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Text } from '@hangar/web-components/core/Text';
import { Skeleton } from '@hangar/web-components/core/Skeleton';
import { useTranslation } from '../../hooks/i18n';
import { ROUTES, type FlightChangeDetailLocationState } from '../../router/routes';
import * as S from './FlightChangeDetails.styles';

export const FlightChangeDetailsSkeleton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const listReturnPath =
    (location.state as FlightChangeDetailLocationState | null)?.flightCasesListReturnTo ?? ROUTES.DASHBOARD;

  return (
    <S.Container data-testid="flight-change-detail-skeleton">
      <S.Content>
        <S.SkeletonBackLink>
          <S.SkeletonBackButton
            type="button"
            onClick={() => navigate(listReturnPath)}
          >
            ← {t('navigation.backToList')}
          </S.SkeletonBackButton>
        </S.SkeletonBackLink>
        <S.SkeletonHeaderShadows>
          <Skeleton />
          <Skeleton />
        </S.SkeletonHeaderShadows>
        <S.SkeletonHeaderCard>
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} />
          ))}
        </S.SkeletonHeaderCard>
        <S.SkeletonCard>
          <S.SkeletonCardTitle>
            <Text variant="heading-md">{t('itinerary.title')}</Text>
          </S.SkeletonCardTitle>
          <S.SkeletonItineraryBlocks>
            <Skeleton />
            <Skeleton />
          </S.SkeletonItineraryBlocks>
        </S.SkeletonCard>
        <S.SkeletonFormCard>
          <S.SkeletonTwoCols>
            <S.SkeletonCol>
              <S.SkeletonCardTitle>
                <Text variant="heading-md">{t('flightChangeDetails.changeCodeForm.changeReason.title')}</Text>
              </S.SkeletonCardTitle>
              <S.SkeletonBlock><Skeleton /></S.SkeletonBlock>
              <S.SkeletonBlock><Skeleton /></S.SkeletonBlock>
              <S.SkeletonBlock><Skeleton /></S.SkeletonBlock>
            </S.SkeletonCol>
            <S.SkeletonCol>
              <S.SkeletonCardTitle>
                <Text variant="heading-md">{t('flightChangeDetails.changeCodeForm.observations.title')}</Text>
              </S.SkeletonCardTitle>
              <S.SkeletonBlock><Skeleton /></S.SkeletonBlock>
              <S.SkeletonBlock $tall><Skeleton /></S.SkeletonBlock>
            </S.SkeletonCol>
          </S.SkeletonTwoCols>
        </S.SkeletonFormCard>
      </S.Content>
    </S.Container>
  );
};
